import type {DropdownLinkData} from '@yandex-delivery/order-layout-blocks'

import {appConfig, i18n} from 'src/shared/config'

import {countryData} from './country-consts'

const {countryCode, tld} = appConfig

export function getCountryButton(): {
  button: {
    label: string | JSX.Element
  }
  list: Array<DropdownLinkData>
} {
  const label =
    countryData.find(data => data.tld === tld)?.label ||
    countryData.find(data => data.countryCode === countryCode)?.label ||
    i18n('order.header.country.russia', 'Россия')
  const list = countryData.filter(data => data.label !== label)

  return {
    button: {
      label,
    },
    list,
  }
}
